/* Urbanek · Nowości scena: scena przypięta, przewijanie strony zmienia smaki.
   Komputer: smak przełącza się krokami, przejście robi CSS.
   Telefon z obsługą animacji sterowanych przewijaniem: ruch słoików liczy przeglądarka (klasa urb-ns--sda),
   skrypt tylko ustawia link strzałki i kolejność warstw. Starsze telefony: jak komputer.
   Tytuł i podpis wchodzą raz po pojawieniu się sceny.
   Styl „jeden słoik”: skrypt ustawia też kolor sceny aktywnego smaku. */
(function () {
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 989px)');
  var sdaOk = window.CSS && CSS.supports && CSS.supports('animation-timeline: view()');

  function headerHeight() {
    var h = document.querySelector('.section-header');
    if (!h) return 0;
    var pos = getComputedStyle(h).position;
    return pos === 'sticky' || pos === 'fixed' ? h.offsetHeight : 0;
  }

  function init(root) {
    if (!root || root.dataset.urbNsReady) return;
    root.dataset.urbNsReady = '1';
    if (!calm) root.classList.add('urb-ns--js');

    var lines = Array.prototype.map.call(root.querySelectorAll('.urb-ns__line'), function (line) {
      var t = {
        track: line.querySelector('[data-urb-ns-track]'),
        stage: line.querySelector('[data-urb-ns-stage]'),
        jars: Array.prototype.slice.call(line.querySelectorAll('[data-urb-ns-jar]')),
        big: Array.prototype.slice.call(line.querySelectorAll('.urb-ns__big span')),
        go: line.querySelector('[data-urb-ns-go]'),
        solo: line.classList.contains('urb-ns__line--solo'),
        tints: Array.prototype.slice.call(line.querySelectorAll('.urb-ns__tints span')),
        veils: Array.prototype.slice.call(line.querySelectorAll('.urb-ns__veils span')),
        active: -1
      };
      t.n = Math.max(1, t.jars.length);
      t.track.style.setProperty('--ns-n', t.n);
      return t;
    });

    function show(t, a) {
      if (t.active === a) return;
      t.active = a;
      t.jars.forEach(function (j, i) { j.style.setProperty('--o', i - a); });
      t.big.forEach(function (s, i) { s.classList.toggle('is-on', i === a); });
      t.tints.forEach(function (s, i) { s.classList.toggle('is-on', i === a); });
      t.veils.forEach(function (s, i) { s.classList.toggle('is-on', i === a); });
      if (t.go && t.jars[a]) t.go.href = t.jars[a].getAttribute('href');
      // jeden słoik: kolor strzałki; tło przenikają warstwy koloru
      if (t.solo && t.jars[a] && t.jars[a].dataset.nsC) t.stage.style.setProperty('--ns-stage', t.jars[a].dataset.nsC);
    }

    function span(t) { return Math.max(1, t.track.offsetHeight - t.stage.offsetHeight); }
    function stick(t) { return parseFloat(getComputedStyle(t.stage).top) || 0; }

    lines.forEach(function (t) {
      show(t, 0);
      t.jars.forEach(function (j, i) {
        j.addEventListener('click', function (e) {
          if (i === t.active) return;
          e.preventDefault();
          var y = window.scrollY + t.track.getBoundingClientRect().top - stick(t) + span(t) * ((i + 0.5) / t.n);
          window.scrollTo({ top: y, behavior: calm ? 'auto' : 'smooth' });
        });
      });
    });

    // telefon: napis w tle dopasowany do sceny, żeby był cały widoczny (także pod kątem); liczone tylko przy zmianie rozmiaru
    var angle = parseFloat(root.getAttribute('data-urb-ns-angle')) || 0;
    var q = /[?&]kat=(-?\d+)/.exec(window.location.search);
    if (q) angle = -Math.min(45, Math.abs(parseFloat(q[1])));
    root.style.setProperty('--ns-angle', angle);
    function fitWords() {
      lines.forEach(function (t) {
        var box = t.big[0] && t.big[0].parentNode;
        if (!box || t.solo) return;
        if (!mobile.matches) { t.big.forEach(function (s) { s.style.fontSize = ''; }); return; }
        var w = box.clientWidth, h = box.clientHeight, a = Math.abs(angle) * Math.PI / 180;
        var room = a < 0.01 ? w : Math.min(w / Math.cos(a), h / Math.sin(a));
        room *= 0.9;
        t.big.forEach(function (s) {
          s.style.fontSize = '100px';
          var nat = s.offsetWidth || 1;
          var fs = Math.min(100 * room / nat, (a < 0.01 ? h : room) * 0.42, 150);
          s.style.fontSize = Math.max(28, Math.round(fs)) + 'px';
        });
      });
    }

    function setMode() {
      root.classList.toggle('urb-ns--sda', !!(sdaOk && mobile.matches && !calm));
    }

    var ticking = false, lastHdr = -1;
    function update() {
      ticking = false;
      var hdr = headerHeight();
      if (hdr !== lastHdr) { lastHdr = hdr; root.style.setProperty('--ns-hdr', hdr + 'px'); }
      lines.forEach(function (t) {
        var r = t.track.getBoundingClientRect();
        if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
        var p = Math.min(1, Math.max(0, (stick(t) - r.top) / span(t)));
        var a = Math.min(t.n - 1, Math.floor(p * t.n));
        // telefon z ruchem liczonym przez przeglądarkę: aktywny smak to najbliższy postój z klatek sekcji
        // (16% toru na start, potem równe odcinki), żeby kolor sceny zmieniał się razem ze słoikiem
        if (t.n > 1 && root.classList.contains('urb-ns--sda')) {
          a = Math.min(t.n - 1, Math.max(0, Math.round((p * 100 - 16) / ((100 - 16) / (t.n - 1)))));
        }
        show(t, a);
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

    setMode();
    if (mobile.addEventListener) mobile.addEventListener('change', function () { setMode(); onScroll(); });
    window.addEventListener('scroll', onScroll, { passive: true });
    // pasek adresu na telefonie zmienia wysokość okna przy przewijaniu: napisy liczymy tylko przy zmianie szerokości
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      onScroll();
      if (window.innerWidth !== lastW) { lastW = window.innerWidth; fitWords(); }
    });
    if (mobile.addEventListener) mobile.addEventListener('change', fitWords);
    update();
    fitWords();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitWords);

    // tytuł i podpis: raz, gdy scena zacznie wjeżdżać na ekran (wcześnie, żeby skończyły się przed ruchem słoików)
    if (calm || !('IntersectionObserver' in window)) {
      lines.forEach(function (t) { t.stage.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      lines.forEach(function (t) { io.observe(t.stage); });
    }
  }

  function boot() { document.querySelectorAll('[data-urb-ns]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-urb-ns]');
    if (el) { el.dataset.urbNsReady = ''; init(el); }
  });
})();
